export const UpdateIcon = ({ color = "#28292B" }: { color?: string }) => {
    return (
        <svg
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1 1V8.5H1.87228M24.9072 11.5C24.169 5.58053 19.1194 1 13 1C7.96393 1 3.65244 4.10225 1.87228 8.5M1.87228 8.5H8.5M25 25V17.5H24.1277M24.1277 17.5C22.3476 21.8977 18.0361 25 13 25C6.88057 25 1.83099 20.4195 1.09284 14.5M24.1277 17.5H17.5"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
